import React from "react";
import { Sparkle } from "lucide-react";
import { useGallery } from "../hooks/useSiteContent";

const defaultLogos = [
  { src: "/assets/logos/applevel.png", alt: "AppLevel" },
  { src: "/assets/logos/great-awakener.jpg", alt: "Great Awakener" },
  { src: "/assets/logos/tuestima-magazine.png", alt: "TuESTIMA Magazine" },
  { src: "/assets/logos/mamas-tuestima.jpg", alt: "Mamas TuESTIMA" },
  { src: "/assets/logos/the-tarot-ship-jimmy.jpg", alt: "The Tarot Ship Jimmy" },
  { src: "/assets/logos/img-7056.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7057.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7058.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7059.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7060.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7061.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7062.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7063.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7064.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7065.png", alt: "Partner brand" },
  { src: "/assets/logos/img-7066.png", alt: "Partner brand" },
];

export default function Brands() {
  const remote = useGallery("brands");
  const logos = remote && remote.length > 0
    ? remote.map((r) => ({ src: r.src, alt: r.alt || r.caption || "Partner brand" }))
    : defaultLogos;
  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="relative bg-[#080808] py-16 md:py-24 lg:py-32 border-y border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Masthead */}
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#7FB3D5]/40" />
            <Sparkle className="w-3 h-3 text-[#7FB3D5]" fill="#7FB3D5" strokeWidth={0.6} />
            <span
              data-testid="brands-eyebrow"
              className="text-[10px] uppercase tracking-[0.4em] text-[#7FB3D5]"
            >
              Selected clients &amp; partners
            </span>
            <Sparkle className="w-3 h-3 text-[#7FB3D5]" fill="#7FB3D5" strokeWidth={0.6} />
            <span className="w-10 h-px bg-[#7FB3D5]/40" />
          </div>

          <h2
            data-testid="brands-headline"
            className="font-display text-3xl md:text-5xl lg:text-6xl text-white font-light leading-tight tracking-tight max-w-3xl"
          >
            Brands we&apos;ve
            <span className="italic text-[#7FB3D5]"> partnered </span>
            with.
          </h2>

          <p className="mt-5 text-sm md:text-base text-white/55 max-w-2xl leading-relaxed">
            A growing circle of founders, creators, magazines, lifestyle and
            wellness brands who&apos;ve trusted NOVA Media PR to shape their
            visibility and partnerships.
          </p>
        </div>

        {/* Logo wall */}
        <div
          data-testid="brands-grid"
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-8 gap-px bg-white/10 border border-white/10"
        >
          {logos.map((logo, i) => (
            <div
              key={i}
              data-testid={`brand-logo-${i}`}
              className="group relative aspect-[5/3] bg-[#f5f2eb] flex items-center justify-center p-5 md:p-7 overflow-hidden hover:bg-white transition-colors duration-500"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                className="max-w-full max-h-full object-contain transition-transform duration-700 group-hover:scale-105 select-none"
                draggable={false}
              />
              <span className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <Sparkle className="w-2.5 h-2.5 text-[#7FB3D5]" fill="#7FB3D5" strokeWidth={0.6} />
              </span>
            </div>
          ))}
        </div>

        <p
          data-testid="brands-footnote"
          className="mt-8 md:mt-10 text-center text-[10px] uppercase tracking-[0.3em] text-white/40"
        >
          ✦ A selection — full client roster shared on request ✦
        </p>
      </div>
    </section>
  );
}
